module.exports = __webpack_public_path__ + "img/puzzel1-2.0e2043d2.png";